import { useNavigate, useRouter } from "@tanstack/react-router";

export function useBackNavigation(fallbackTo = "/find") {
    const router = useRouter();
    const navigate = useNavigate();

    return () => {
        const tsrIndex = (window.history.state as { __TSR_index?: number })
            ?.__TSR_index;

        if (typeof tsrIndex === "number" && tsrIndex > 0) {
            router.history.back();
        } else {
            navigate({ to: fallbackTo });
        }
    };
}
